import React from 'react';
import MenuDashboard from "./Menu";
import "./css/dashboard.css";
import HeaderMember from "./HeaderMember";
import ListeCmd from "./ListeCmd";
import {
    UserOutlined,
    SettingFilled,
    SmileOutlined,
    SyncOutlined,
    LoadingOutlined,
    SolutionOutlined,
} from '@ant-design/icons';

import {Form, Input, Button, Checkbox, Row, Col, Typography, Divider, Steps, Layout, Tabs} from 'antd';
import {FooterApps} from "../order/inc/FooterApps";
import {t} from '../../constant/i18n';

const {Title, Text, Link} = Typography;
const {Step} = Steps;
const {TabPane} = Tabs;

export default function Order() {
    return (
        <Layout>
            <HeaderMember/>
            <Layout>
                <MenuDashboard/>
                <div className="contentBox">
                    <Title>{t('order.myProjects')}</Title>
                    <Text>{t('order.projectsDesc')}</Text>
                    <Divider/>
                    <Tabs defaultActiveKey="1">
                        <TabPane tab={t('order.tabApplications')} key="1">
                            <ListeCmd filter="encours" title={t('order.titleApplications')}/>
                        </TabPane>
                        <TabPane tab={t('order.tabInProgress')} key="2">
                            <ListeCmd filter="valider" title={t('order.titleValidated')}/>
                        </TabPane>
                        <TabPane tab={t('order.tabFinished')} key="3">
                            <ListeCmd filter="projettermine" title={t('order.titleFinished')}/>
                        </TabPane>
                        <TabPane tab={t('order.tabCancelled')} key="4">
                            <ListeCmd filter="annulee" title={t('order.titleCancelled')}/>
                        </TabPane>

                    </Tabs>


                </div>
            </Layout>
            <Divider dashed/>
            <FooterApps/>
        </Layout>
    );
}



